module.exports = __webpack_public_path__ + "img/az.47257e66.svg";